import * as React from 'react';
import { Inbox } from 'lucide-react';
import { cn } from '../cn';

export interface EmptyStateProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: React.ReactNode;
  message?: React.ReactNode;
  icon?: React.ReactNode;
  /** Primary next action(s). */
  action?: React.ReactNode;
}

/**
 * EDS governed Empty state — Design Bible §7.4/§10.
 * Never a blank region: always icon + guidance + (optional) next action.
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  message,
  icon,
  action,
  className,
  ...props
}) => (
  <div
    className={cn(
      'flex flex-col items-center justify-center gap-3 rounded-eds-md border border-dashed border-eds-border bg-eds-surface px-6 py-12 text-center',
      className,
    )}
    {...props}
  >
    <span className="flex h-11 w-11 items-center justify-center rounded-eds-pill bg-eds-muted text-eds-muted-fg" aria-hidden="true">
      {icon ?? <Inbox className="h-5 w-5" />}
    </span>
    <div>
      <p className="font-eds-display text-base font-semibold text-eds-fg">{title}</p>
      {message && <p className="mt-1 max-w-sm font-eds-body text-sm text-eds-muted-fg">{message}</p>}
    </div>
    {action && <div className="mt-1 flex flex-wrap items-center justify-center gap-2">{action}</div>}
  </div>
);

export default EmptyState;
